import React from 'react';
import styled from 'styled-components';
import { TimeListItem } from './TimeListItem';

const TimeListDiv = styled.div`
  position: relative;
  
  .time-list__items-container {
    overflow: hidden;
    a {
      width: 50%;
      float: left;
      box-sizing: border-box;
      
      &:nth-child(2n) {
        padding-left: 2%;
      }
      
      &:nth-child(2n +1) {
        padding-right: 2%;
      }
    }
  }
`;

export class TimeList extends React.Component {
  constructor() {
    super();
    this.thiprevDisabled = false;
  }

  _listItemSelected = (item) => {
    window.console.log('Selected item', item);
  };

  _listItems() {
    return this.props.times.map((time) => {
      return (
        <TimeListItem pro={this.props.pro} location={this.props.location} item={time} key={time.id} onItemClick={this._listItemSelected} />
      );
    });
  }

  componentDidUpdate(){
  if(window.parent && window.self !== window.top) { // if embedded
      if(this.container && this.container.scrollHeight > 0){
        const container = document.getElementById('private-calendar');
        if(container && container.scrollHeight > 0){
          try {
            const msg = {
              event: 'BTIframeResize',
              height: container.scrollHeight,
            };
            window.parent.window.postMessage(JSON.stringify(msg), '*');
          } catch(e) {};
        }
      }
    }
  }

  render() {
    if (this.props.date) {
      return (
        <TimeListDiv>
          <div ref={el => this.container = el} className="time-list__items-container">
            {this._listItems()}
          </div>
        </TimeListDiv>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/pros/components/TimeList.js